// extracted by mini-css-extract-plugin
export default {"Card":"OptionCard_Card__qvXEg","Blue":"OptionCard_Blue__ZhJQe","Yellow":"OptionCard_Yellow__qV4vd","Title":"OptionCard_Title__CbEih"};